import React from "react";
import { Box, Container, Image, Heading, Text, Flex } from "@chakra-ui/react";
import brandsdevider from "../../../assets/about/brandsdevider.png";
import brand1 from "../../../assets/about/brand1.png";
import brand2 from "../../../assets/about/brand2.png";

// Shark Tank images
import badge from "../../../assets/home/slogo.png";
import pointer from "../../../assets/home/spointer.png";
import sharktank from "../../../assets/home/stank.png";
import pointer1 from "../../../assets/home/lpointer.png";
import badge1 from "../../../assets/home/logo.png";
import FlowerImage from "component/FlowerImage";
import cream from "../../../assets/flower/cream.png";
import grey from "../../../assets/flower/greyish.png";

const brandLogos = [
  brand1,
  brand2,
  brand2,
  brand2,
  brand2,
  brand2,
  brand2,
  brand2,
];

const Successstories = () => {
  return (
    <Box bg="#005770" color="white" py={0} position="relative">
      <FlowerImage
        src={cream}
        top={{ base: "20", md: "20" }}
        left={{ base: "10", md: "20" }}
      />
      <FlowerImage
        src={grey}
        top={{ base: "60", md: "60" }}
        right={{ base: "10", md: "20" }}
      />
      <Container
        maxW="container.xl"
        display="flex"
        flexDirection={{ base: "column", md: "row" }}
        alignItems="center"
        justifyContent="space-between"
        textAlign={{ base: "center", md: "left" }}
      >
        {/* Heading Section with Flower */}
        <Box
          display="flex"
          alignItems="center"
          gap={4}
          width={{ base: "100%", md: "100%" }}
          flexDirection={{ base: "column", md: "row" }}
          justifyContent={{ base: "center", md: "center" }}
          py={8}
          className="fade-in-up"
        >
          <Image
            src={badge1}
            alt="Badge"
            position="absolute"
            left={{ base: "82%", md: "66%" }}
            top={{ base: "65", md: "10" }}
            boxSize={{ base: "60px", md: "70px" }}
            data-animated = 'true'
          />
          <Image
            src={pointer1}
            alt="Pointer"
            position="absolute"
            top="10px"
            left={{ base: "77%", md: "62%" }}
            boxSize={{ base: "60px", md: "69px" }}
            data-animated = 'true'
          />

          <Box>
            <Heading
              fontSize={{ base: "2xl", md: "3xl" }}
              fontWeight="bold"
              zIndex={2}
              className="fade-in-up"
            >
              We’re Trusted By{" "}
              <Text as="span" color="#BFA585" fontStyle="italic" className="fade-in-up">
                Brands
              </Text>
            </Heading>
          </Box>
        </Box>
      </Container>

      {/* Scrolling Brand Logos */}
      <Box mt={8} overflow="hidden" whiteSpace="nowrap" className="fade-in-up">
        <Flex className="marquee">
          {brandLogos.map((logo, index) => (
            <Image
              key={index}
              src={logo}
              alt={`Brand ${index + 1}`}
              mx={4}
              height="60px"
              width="auto"
              
            />
          ))}
        </Flex>
      </Box>

      {/* Shark Tank Section */}
      <Box mt={4} position="relative" h="180px" className="fade-in-up">
        {/* Badge */}
        <Image
          src={badge}
          alt="Badge"
          position="absolute"
          left={{ base: "10%", md: "30%" }}
          top={{ base: "34px", md: "27px" }}
          width={"167px"}
          data-animated = 'true'
          // boxSize={{ base: "140px", md: "150px" }}
        />
        {/* Pointer */}
        <Image
          src={pointer}
          alt="Pointer"
          position="absolute"
          top={{ base: "78px", md: "60px" }}
          left={{ base: "23%", md: "37%" }}
          boxSize={{ base: "120px", md: "127px" }}
          data-animated = 'true'
        />
        {/* Shark Tank Logo */}
        <Image
          src={sharktank}
          alt="Shark Tank"
          position="absolute"
          top={{ base: "96px", md: "60px" }}
          left={{ base: "59%", md: "51%" }}
          transform="translateX(-50%)"
          boxSize={{ base: "100px", md: "140px" }}
          data-animated = 'true'
        />
      </Box>

      <Image src={brandsdevider} mt={16} width="100%" />

      {/* Animation CSS */}
      <style>
        {`
          @keyframes scroll {
            from {
              transform: translateX(0);
            }
            to {
              transform: translateX(-50%);
            }
          }

          .marquee {
            display: flex;
            width: max-content;
            animation: scroll 15s linear infinite;
          }
        `}
      </style>
    </Box>
  );
};

export default Successstories;
